import { render } from "./LbrxLogoutPopup.vue?vue&type=template&id=dcb072c6&scoped=true"
import script from "./LbrxLogoutPopup.vue?vue&type=script&lang=js"
export * from "./LbrxLogoutPopup.vue?vue&type=script&lang=js"

import "./LbrxLogoutPopup.vue?vue&type=style&index=0&id=dcb072c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb072c6"]])

export default __exports__